
import { useEffect, useState } from 'react';

import { Button, Image, CenterPopup, Skeleton, Toast, Dialog } from 'antd-mobile';
import './pay.scss';
import { getWxConfig } from '../../../apis/common';

import wx from 'weixin-js-sdk';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { checkCaseOrder, getCaseProjectList, ICasePay, ICasePayType1, ICasePayType2, ICaseProjectData, toCasePay } from '../../../apis/casePay';

export function CasePayPage() {
    document.title = '支付页';

    const [uRLSearchParams, setURLSearchParams] = useSearchParams();

    const [projectList, setProjectList] = useState<ICaseProjectData[]>([]);

    const [projectId, setProjectId] = useState<number>();

    // 初始化
    useEffect(() => {
        Toast.show({
            icon: 'loading',
            content: '加载中',
            duration: 0,
            maskClickable: false
        });

        getCaseProjectList({ package_type: Number(uRLSearchParams.get('type')) }).then(res => {
            setProjectList(res.data.list);
        })

        getWxConfig().then(({ data }) => {
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: data.appId, // 必填，公众号的唯一标识
                timestamp: data.timestamp, // 必填，生成签名的时间戳
                nonceStr: data.nonceStr, // 必填，生成签名的随机串
                signature: data.signature,// 必填，签名
                jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表chooseWXPay为支付js接口
            });
        });
    }, []);

    wx.ready(() => {
        Toast.clear();
    });

    wx.error((err) => {
        Toast.clear();
        console.log(err);
        Toast.show({
            content: 'jssdk初始化失败',
            position: 'bottom',
        })
    });

    const toPay = async () => {
        Toast.show({
            icon: 'loading',
            content: '加载中',
            duration: 0,
            maskClickable: false
        });

        if (projectId) {
            try {
                let { data } = await toCasePay({
                    package_id: projectId,
                });
                payFunc(data);
            } catch (e) {
                console.log(e);
            }
        }

        Toast.clear();
    }

    // 支付执行方法
    const payFunc = (data: ICasePay) => {
        switch (data.pay_type) {
            case 1:
                /**
                 * 微信支付
                 */
                let payment1 = data.payment as ICasePayType1;
                wx.chooseWXPay({
                    timestamp: payment1.timestamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
                    nonceStr: payment1.nonceStr, // 支付签名随机串，不长于 32 位
                    package: payment1.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                    signType: payment1.signType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                    paySign: payment1.paySign, // 支付签名
                    success: (res) => {
                        // 支付成功后的回调函数
                        console.log(res);
                        Toast.show({
                            icon: 'success',
                            content: '支付成功请稍后',
                            duration: 5000,
                            afterClose: () => navigate('/', { replace: true }),
                            maskClickable: false
                        });
                    }
                });
                break;
            case 2:
                /**
                 * 二维码支付
                 */
                let payment2 = data.payment as ICasePayType2;
                setPayQRcode(payment2.offline_pay_url);
                setPayQRcodeVisible(true);
                break;

            default:
                Toast.show({
                    icon: 'fail',
                    content: '支付响应参数错误',
                    duration: 5000,
                    maskClickable: false
                })
                break;
        }
    }

    useEffect(() => {
        if (projectId) {
            Toast.show({
                icon: 'loading',
                content: '加载中',
                duration: 0,
                maskClickable: false
            });

            checkCaseOrder({ package_id: projectId }).then(res => {
                setMoney(res.data.money);
            }).finally(() => {
                Toast.clear();
            })
        }
    }, [projectId])

    const [money, setMoney] = useState<number>();

    const onProjectSelected = async (id: number) => {
        setProjectId(id);
    }

    const navigate = useNavigate();

    // 支付二维码弹出
    const [payQRcodeVisible, setPayQRcodeVisible] = useState(false);
    const [payQRcode, setPayQRcode] = useState<string>();
    const paid = async () => {
        const result = await Dialog.confirm({
            content: '确定已经支付？即将跳转回首页。',
            cancelText: '还未支付'
        })
        if (result) {
            setPayQRcodeVisible(false);
            navigate('/', { replace: true });
        }
    }

    return (
        <div className='pay'>
            {
                projectList ?
                    <>
                        <div className='selector' style={{ padding: '20px 10px 0 10px' }}>
                            {
                                projectList.map(item => (
                                    <div className={`item ${projectId && item.id === projectId ? 'active' : ''}`} onClick={() => onProjectSelected(item.id)}>
                                        {/* {item.label && <div className='title'>{item.label}</div>} */}
                                        <div className='time'>{item.title}</div>
                                        <div className='price'>
                                            <div>￥<span>{item.price}</span></div>
                                            {/* <div>￥{item.price}</div> */}
                                        </div>
                                        <div className='month'>(提问{item.ask_times}次/旁听{item.listen_times}次)</div>
                                        <div className='month'>有效期：{item.duration}{item.duration_type_text}</div>
                                        {/* <div className='discount'>{item.duration}{item.duration_type_text}</div> */}
                                    </div>
                                ))
                            }
                        </div>
                        {/* <Card title='项目介绍'>
                            <div style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: projectId ? (projectList.find(item => item.id === projectId)?.content ?? '暂无介绍') : '请选择要购买的项目' }}></div>
                        </Card> */}
                    </>
                    : <Skeleton animated style={{ width: '100%', height: 100 }} />
            }

            <Button className='button' block color='primary' size='large' disabled={!projectId} onClick={toPay}>
                立即支付 {
                    money ? ` ${money}元` : ''
                }
            </Button>

            {/* 支付二维码弹出 */}
            <CenterPopup
                visible={payQRcodeVisible}
                closeOnMaskClick={false}
                showCloseButton={true}
                onClose={() => {
                    setPayQRcodeVisible(false)
                }}
                bodyStyle={{ height: '80vh' }}
            >
                <div className='qrcode-box'>
                    <Image className='qrcode-box__img' src={payQRcode} />
                    <Button className='qrcode-box__btn' color='primary' onClick={paid}>我已支付</Button>
                </div>

            </CenterPopup>
        </div>
    );
}